import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] px-4 py-5 text-center text-[10px] leading-snug text-white/60 sm:px-6 sm:text-xs" data-id="element-61" data-mp="32wd2qgad7ltj">
      <p className="mx-auto mb-2 max-w-xl" data-id="element-62" data-mp="3ghc0bvkn0rl2">
        © 2026 BOXING COACH PRO™ — All Rights Reserved. The information provided is intended for
        educational purposes and as a professional resource for boxing coaches. Coaches should always
        prioritize athlete safety, proper technical instruction, appropriate training loads,
        individual skill levels, and progressive development when applying any session or exercise
        included in this system.
      </p>
      <nav aria-label="Legal links" className="mb-1 flex justify-center gap-2 font-heading font-semibold" data-id="element-63" data-mp="3ldu874b9l61m">
        <a href="#" className="hover:text-brand-red" data-id="element-64" data-mp="29z6tk9nn6feu">
          Terms &amp; Conditions
        </a>
        <span data-id="element-65" data-mp="2eya05yj9stox">•</span>
        <a href="#" className="hover:text-brand-red" data-id="element-66" data-mp="2eyt76k7dtxo6">
          Privacy Policy
        </a>
        <span data-id="element-67" data-mp="3l9acngdir03d">•</span>
        <a href="#" className="hover:text-brand-red" data-id="element-68" data-mp="3l8qxu8j60rtk">
          Contact
        </a>
      </nav>
      <p data-id="element-69" data-mp="3gb8x35faxiwn">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="font-semibold hover:text-brand-red" data-id="element-70" data-mp="3gc0ixoj3k29q">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}